import { Button, Heading, Pane, Spinner, toaster } from 'evergreen-ui'
import { useEffect, useState } from 'react'

import { getSiteDeploys } from '~/api/deploys'
import { getSites } from '~/api/sites'
import Flex from '~/components/Flex'
import NetlifyDeploy from '~/components/NetlifyDeploy'
import NetlifySite from '~/components/NetlifySite'
import { ArrowLeftIcon } from '~/icons/evergreen'
import { IDeploy } from '~/interfaces/netlify/Deploy'
import { ISite } from '~/interfaces/netlify/Site'

export default function DevListDeploys() {
  const [sites, setSites] = useState([] as ISite[])
  const [deploys, setDeploys] = useState([] as IDeploy[])
  const [siteID, setSiteID] = useState('')
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    // override overflow: hidden in normalize.css
    document.body.style.overflow = 'auto'
    setLoading(true)
    getSites()
      .then(mySites => {
        const sortedSites = mySites.sort((a, b) =>
          new Date(a.updatedAt).getTime() < new Date(b.updatedAt).getTime() ? 1 : -1
        )
        setSites(sortedSites)
      })
      .finally(() => setLoading(false))
  }, [])

  const handleSiteClick = (id: string) => {
    setSiteID(id)
    getSiteDeploys(id).then(siteDeploys => {
      const deployPreviews = siteDeploys
        .filter(d => d.context !== 'production')
        .sort((a, b) => {
          if (a.context === b.context) {
            return new Date(a.updatedAt).getTime() > new Date(b.updatedAt).getTime() ? -1 : 1
          }
          return a.context === 'deploy-preview' ? -1 : 1
        })

      if (deployPreviews.length === 0) {
        toaster.danger('No deploy previews in that project, try another one!')
      } else {
        setDeploys(deployPreviews)
        window.scrollTo(0, 0)
      }
    })
  }

  const handleDeployClick = (deployID: string) => {
    document.location.assign(`/?deployID=${deployID}&siteID=${siteID}`)
  }

  const goBack = () => {
    setDeploys([])
  }

  return (
    <Flex background="tint2" justifyContent="center" minHeight="100vh" width="100%">
      {isLoading && <Spinner />}
      {deploys.length === 0 ? (
        <Pane marginY={40}>
          {!isLoading && (
            <Heading marginBottom="default" size={600}>
              Choose a project
            </Heading>
          )}
          {sites.map(site => (
            <NetlifySite key={site.id} handleClick={handleSiteClick} site={site} />
          ))}
        </Pane>
      ) : (
        <Pane marginY={40}>
          <Button iconBefore={ArrowLeftIcon} marginBottom={32} onClick={goBack}>
            Back
          </Button>
          <Heading marginBottom="default" size={600}>
            Choose a deploy
          </Heading>
          {deploys.map(deploy => (
            <NetlifyDeploy key={deploy.id} deploy={deploy} handleClick={handleDeployClick} />
          ))}
        </Pane>
      )}
    </Flex>
  )
}
